import { Shark, Utils } from "shark-mvc";
// import moment from "moment-timezone";

import NousCoreModel from "./NousCoreModel";

class Client extends NousCoreModel {
	// active = true;
	fixedHourlyValue = 0;
	hasFixedHourlyValue = false;
	name = "";
	organizationGuid = "";
	ownerGuid = "";
	totalInternalCostLabel = "";
	totalExternalCostLabel = "";
	totalInvoiceValueLabel = "";

	__cssClasses = new Set();
	__cssClassesString = "";
	__currUserCanEdit = false;
	__organizationLabel = "";
	__paymentCalculationTypeLabel = "";
	__statusLabel = "";

	constructor (data) {
		super();
		
		// Alice Was here
		// Alice: ask Dave where to put this variables:
		this.__isFixedHoulyRate = false;// Deprecated
		this.__isUserHourlyRate = false;// Deprecated
		this.__isQuotation = false;// Deprecated

		this.businessName = "";
		this.description = "";
		this.reportSettings = {
			columns: {
				printable: {

				},
				visible: {
					duration: true,
					durationSec: true,
					moneyAmount: true,
					projectName: true,
					referencePeriod: true,
					tags: true,
					taskName: true,
					totalDuration: true,
					totalMoneyAmount: true,
				}
			}
		};


		// Deprecated
		this.paymentCalculationType = 0;//[1: Valore orario fisso, 2: Valore orario per utente, 3: Progetti a preventivo]

		this.tags = [];
			
		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		// exportData.active = this.exportBooleanField("active");
		exportData.reportSettings = this.exportObjectField("reportSettings");
		exportData.tags = this.exportArrayField("tags");
				
		return exportData;
	}

	flattenCSSClasses () {
		this.__cssClassesString = "";
		this.__cssClasses.forEach(item => this.__cssClassesString += " " + item);
	}

	import (data, options) {
		super.import(data, options);

		// this.importBooleanField("active", data.active);
		// this.importDateField("createdAt", data.createdAt);
		this.importNumberField("fixedHourlyValue", data.fixedHourlyValue);
		this.importNumberField("paymentCalculationType", data.paymentCalculationType);
		// this.importNumberField("status", data.status);
		// this.importDateField("updatedAt", data.updatedAt);

		this.parseOrganization();
		this.parsePaymentCalculationType();
		this.parseStatus();
	}

	onOrganizationGuidChanged () {
		this.parseOrganization();
	}

	onPaymentCalculationTypeChanged () {
		this.parsePaymentCalculationType();
		Shark.render();
		// console.log("*****************************   ATTENZIONE: SE NON STAI MODIFICANDO UN CLIENTE AVVISA DAVE!!!   *********************************");
		// console.log("*****************************   ATTENZIONE: SE NON STAI MODIFICANDO UN CLIENTE AVVISA DAVE!!!   *********************************");
		// console.log("*****************************   ATTENZIONE: SE NON STAI MODIFICANDO UN CLIENTE AVVISA DAVE!!!   *********************************");
	}

	onStatusChanged () {
		this.parseStatus();
	}

	parseOrganization() {
		const { organizationList } = Shark.get();

		if (organizationList) {
			const organization = Utils.safp(organizationList, "guid", this.organizationGuid);

			if (organization) {
				const { currUser } = Shark.get();
				this.__currUserCanEdit = organization.ownerGuid === currUser.guid;
				this.__organizationLabel = organization.name;
			}
		}
	}

	parsePaymentCalculationType () {
		switch (this.paymentCalculationType) {
			case 1:
				// Shark.$store.labels.status_active
				this.__paymentCalculationTypeLabel = "Valore orario fisso";
				break;
			case 2:
				// Shark.$store.labels.status_active
				this.__paymentCalculationTypeLabel = "Valore orario per utente";
				break;
			case 3:
				// Shark.$store.labels.status_active
				this.__paymentCalculationTypeLabel = "Progetti a preventivo";
				break;
		}

		this.__isFixedHoulyRate = this.paymentCalculationType === 1;
		this.__isUserHourlyRate = this.paymentCalculationType === 2;
		this.__isQuotation = this.paymentCalculationType === 3;
	}

	parseStatus () {
		switch (this.status) {
			case 1:
				this.__statusLabel = Shark.$store.labels.status_active ;
				break;
			case 2:
				this.__statusLabel = Shark.$store.labels.status_not_active;
				break;
		}
	}

	validate () {
		let errors = [];

		errors = errors.concat(this.validateName());
		errors = errors.concat(this.validateOrganizationGuid());

		return errors;
	}


	validateName () {
		let error = [];

		if (this.name.trim() === "") {
			error.push({
				error: Shark.$store.labels.errors.you_must_insert_customer_name,
				field: "name",
			});
		}

		return error;
	}
	

	validateOrganizationGuid () {
		let error = [];

		if (this.organizationGuid.trim() === "") {
			error.push({
				error: Shark.$store.labels.errors.you_must_select_an_organization,
				field: "organizationGuid",
			});
		}

		return error;
	}
}

Shark.registerModel("Client", Client);

export default Client;